import { render, staticRenderFns } from "./mallOrder.vue?vue&type=template&id=4d1633ae&scoped=true"
import script from "./mallOrder.vue?vue&type=script&lang=js"
export * from "./mallOrder.vue?vue&type=script&lang=js"
import style0 from "./mallOrder.vue?vue&type=style&index=0&id=4d1633ae&prod&lang=css"
import style1 from "./mallOrder.vue?vue&type=style&index=1&id=4d1633ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1633ae",
  null
  
)

export default component.exports